import {MatDialog} from '@angular/material';
import {ChangesHaveBeenSavedDialogComponent} from './changes-have-been-saved-dialog.component';

export function openChangesHaveBeenSavedDialog(dialog: MatDialog): void {
  dialog.open(ChangesHaveBeenSavedDialogComponent);
}
